module.exports = __webpack_public_path__ + "Wireframes1.png?61cfc2ead4915fd976eeda564ef43f60";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes1.png
// module id = 109
// module chunks = 0